// extracted by mini-css-extract-plugin
export default {"feedbackInput":"feedback-overlay_feedbackInput__5za--","alignRight":"feedback-overlay_alignRight__UOtIp"};